import React, { useState, useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { fetchOptions } from '../queries';
import Select from './Select';
import { get } from 'lodash';
import getUsersName from '../../../../helpers/users/utils';

const SelectWithFind = ({ name, query, sort, addNullOption, props, user, findRef, isEdit }) => {
    const [options, setOptions] = useState();
    const {
        clearErrors,
        formState: { errors, defaultValues },
        getValues,
        selectedValues,
        setError,
        setValue,
        updateSelectedValues,
        watch,
        // wrap
    } = useFormContext();
    const { endpoint, where = {}, fields, order, labelKey, roleConstraints, populate, useLoopback } = query;
    const { referenceField, referenceKey, findKey, referenceSubstring, onCreateOnly } = findRef || {};

    useEffect(() => {
        const getOptions = async () => {
            const optionsResponse = await fetchOptions({ endpoint, where, fields, order, labelKey, roleConstraints, user, populate, useLoopback });
            if (optionsResponse.error) {
                setOptions([]);
                setError(name, { type: 'fetch options', message: `Could not fetch ${props.label} options` });
            } else {
                if (sort) {
                    if (sort === 'name') {
                        optionsResponse.sort((a, b) => {
                            const aName = getUsersName(a)?.trim();
                            const bName = getUsersName(b)?.trim();
                            return aName?.localeCompare(bName, undefined, { numeric: true });
                        });
                    } else {
                        optionsResponse.sort((a, b) => get(a, sort)?.localeCompare(get(b, sort), undefined, { numeric: true }));
                    }
                }
                if (addNullOption) optionsResponse.unshift(addNullOption);
                setOptions(optionsResponse);
                clearErrors([name]);
            }
        };

        getOptions();
    }, []);

    useEffect(() => {
        const findOption = () => {
            const reference = !!referenceField && selectedValues[referenceField];
            const splitKey = referenceKey?.split('.');
            const referenceValue = referenceKey ? splitKey.reduce((acc, key) => acc?.[key], reference) : reference;

            if (referenceValue && referenceValue.length >= referenceSubstring[1]) {
                let findValue = referenceSubstring[1] ? referenceValue.substring(referenceSubstring[0], referenceSubstring[1]) : referenceValue;
                if (Array.isArray(findValue)) [findValue] = findValue;
                const found = options.find((opt) => {
                    if (Array.isArray(opt[findKey])) {
                        const existingOpt = opt[findKey].find((o) => o === findValue);
                        return !!existingOpt;
                    }
                    return opt[findKey] === findValue;
                });
                if (found?._id) {
                    updateSelectedValues(name, found);
                    setValue(name, found._id);
                }
            }
        };

        // setValue does not mark field as dirty, so we need to manually check if the value is the default
        const existingValue = getValues(name);
        const defaultValue = defaultValues?.[name];
        const isDefault = existingValue && existingValue === defaultValue;
        const skipFindOption = onCreateOnly && isEdit;
        if (options?.length && !isDefault && !skipFindOption) {
            findOption();
        }
    }, [watch(referenceField), options]);

    return (
        <Select
            name={name}
            labelKey={labelKey}
            props={{ ...props, options }}
            loading={!options && !errors[name]}
            addNullOption={addNullOption}
            // wrap
        />
    );
};

export default SelectWithFind;
